// extracted by mini-css-extract-plugin
export var avatarContainer = "_6b-0";
export var avatarTypingWave = "_6b-i";
export var gray = "_6b-f";
export var green = "_6b-c";
export var icon = "_6b-9";
export var image = "_6b-1";
export var lg = "_6b-6";
export var md = "_6b-5";
export var presenceDot = "_6b-b";
export var red = "_6b-d";
export var sm = "_6b-4";
export var status = "_6b-a";
export var typingDot = "_6b-h";
export var typingPill = "_6b-g";
export var xl = "_6b-7";
export var xs = "_6b-3";
export var xxl = "_6b-8";
export var xxs = "_6b-2";
export var yellow = "_6b-e";